<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Cleopatra Caper</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#i-to-become-a-detective">I: To Become a Detective</a></li>
<li id="toc-li-6"><span href="#/text/ch006#ii-welcome-to-the-middle-east" title="Link target outside of Sample">II: Welcome to the Middle East</span></li>
<li id="toc-li-7"><span href="#/text/ch007#iii-a-city-of-the-dead" title="Link target outside of Sample">III: A City of the Dead</span></li>
<li id="toc-li-8"><span href="#/text/ch008#iv-the-baths-of-cleopatra" title="Link target outside of Sample">IV: The Baths of Cleopatra</span></li>
<li id="toc-li-9"><span href="#/text/ch009#v-to-the-gates-of-purgatory" title="Link target outside of Sample">V: To the Gates of Purgatory</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?0730efce